import { ListResource } from "./resource-details/ListResource";
import { LinkResource } from "./resource-details/LinkResource";
import { ChartResource } from "./resource-details/ChartResource";
import { TableResource } from "./resource-details/TableResource";
import { MapResource } from "./resource-details/MapResource";
import { MapAndImageResource } from "./resource-details/MapAndImageResource";
import { ReportResource } from "./resource-details/ReportResource";
import { ImageResource } from "./resource-details/ImageResource";

interface ResourceDetailsProps {
    resources: any[];
    resourceSelected?: (resource: any) => void;
}

export const ResourceDetails = ({ resources, resourceSelected }: ResourceDetailsProps) => {
    return <>
        {resources.map((resource, index) => {
            resource.options = resource.options || {};
            resource.data = Array.isArray(resource.data) ? resource.data : [];

            return <div key={index}>
                {(() => {
                    // Safeguard against null resources
                    if (!resource || !resource.type || !resource.data) {
                        return <></>;
                    }

                    switch (resource.type) {
                        case 'list': return <ListResource resource={resource}></ListResource>
                        case 'link': return <LinkResource resource={resource}></LinkResource>
                        case 'image': return <ImageResource resource={resource}></ImageResource>
                        case 'chart': return <ChartResource resource={resource}></ChartResource>
                        case 'table': return <TableResource resource={resource}></TableResource>
                        case 'map': return <MapResource resource={resource} resourceSelected={resourceSelected}></MapResource>
                        case 'mapAndImage': return <MapAndImageResource resource={resource}></MapAndImageResource>
                        case 'report': return <ReportResource resource={resource}></ReportResource>
                        default: return <></>;
                    }
                })()}
            </div>
        })}
    </>;
};
